/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs'
import * as ActorDefs from '../actor/defs.defs'

const $nsid = 'chat.bsky.convo.getMessages'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  convoId: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  messages: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageView>(
          (() => ConvoDefs.messageView) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.DeletedMessageView>(
          (() => ConvoDefs.deletedMessageView) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.SystemMessageView>(
          (() => ConvoDefs.systemMessageView) as any,
        ),
      ],
      false,
    ),
  ),
  relatedProfiles: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns a page of messages from a conversation. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['InvalidConvo'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
